<template>
  <v-container fluid style="margin-top: -12px">
    <product-category-company></product-category-company>
  </v-container>
</template>

<script>
import ProductCategoryCompany from "./ProductCategoryCompany";
export default {
  name: "ViewProductCategory",
  components: { ProductCategoryCompany }
};
</script>

<style scoped></style>
